import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
import { Box } from "./Box";
import { mergeSx } from "../system";
export const flexScrollAreaContainerClasses = {
    root: "MinervaFlexScrollAreaContainer-root",
};
/**
 * The FlexScrollAreaContainer component is the container that ensures the FlexScrollArea child can properly scroll its content while allowing other children of a fixed height to shrink the size of the scrolling area
 * NOTICE: This component does not handle scrolling. It must be used in conjunction with a FlexScrollArea to achieve proper scrolling.
 */
export const FlexScrollAreaContainer = forwardRef(({ gap, rowGap, columnGap, flexDirection = "column", justifyContent, alignItems, flexWrap, flex, flexBasis, flexGrow, flexShrink, flexFlow, order, alignSelf, justifySelf, justifyItems, sx, className, ...props }, ref) => (_jsx(Box, { ref: ref, ...props, className: clsx([flexScrollAreaContainerClasses.root, className]), sx: mergeSx({
        gap,
        rowGap,
        columnGap,
        flexDirection,
        justifyContent,
        alignItems,
        flexWrap,
        flex,
        flexBasis,
        flexGrow,
        flexShrink,
        flexFlow,
        order,
        alignSelf,
        justifySelf,
        justifyItems,
        minWidth: 0,
        height: "100%",
        display: "flex",
    }, sx) })));
export const flexScrollAreaClasses = {
    root: "MinervaFlexScrollArea-root",
};
/**
 * The FlexScrollArea component is the child that handles overflow scrolling while allowing other children of a fixed height to shrink the size of the scrolling area when placed in a FlexScrollAreaContainer.
 * NOTICE: Must be used with a FlexScrollAreaContainer parent to achieve proper scrolling.
 */
export const FlexScrollArea = forwardRef(({ disableOverflowControl = false, useContainerBreakpoints = false, gap, rowGap, columnGap, flexDirection, justifyContent, alignItems, flexWrap, flex, flexBasis = 0, flexGrow = 1, flexShrink, flexFlow, order, alignSelf, justifySelf, justifyItems, sx, className, ...props }, ref) => (_jsx(Box, { ref: ref, className: clsx([flexScrollAreaClasses.root, className]), sx: mergeSx({
        gap,
        rowGap,
        columnGap,
        flexDirection,
        justifyContent,
        alignItems,
        flexWrap,
        flex,
        flexBasis,
        flexGrow,
        flexShrink,
        flexFlow,
        order,
        alignSelf,
        justifySelf,
        justifyItems,
        minWidth: 0,
        display: "flex",
        ...(typeof disableOverflowControl === "boolean"
            ? {
                overflow: disableOverflowControl ? "visible" : "auto",
            }
            : {
                [useContainerBreakpoints ? "containerBreakpoints" : "breakpoints"]: {
                    [disableOverflowControl]: {
                        overflow: "auto",
                    },
                },
            }),
    }, sx), ...props })));
//# sourceMappingURL=FlexScrollArea.js.map